import { useContext, type FC } from 'react';
import { Button, CircularProgress } from '@mui/material';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { AppContext } from '../../App';
import useMATExportParams from './hooks/useMATExportParams';
import { matTimestamp } from '../../utils/matTimestamp';
import { useDownloadCsv } from './hooks/useDownloadCsv';
import { btnSubtlePrimarySx } from '../common/filterStyles';

const ExportButton: FC = () => {
  const { isStaff } = useContext(AppContext);
  const params = useMATExportParams();
  const { download, loading } = useDownloadCsv((mat) => mat.exportCsv.bind(mat));

  if (!isStaff) return null;

  const handleExport = () => {
    download('all', params, (i) => `mat-export-${i}-${matTimestamp()}.csv`);
  };

  return (
    <Button
      onClick={handleExport}
      data-cy="btn-export-mat"
      disabled={loading}
      variant="outlined"
      sx={btnSubtlePrimarySx}
      startIcon={
        loading ? <CircularProgress size={14} /> : <CloudDownloadIcon sx={{ fontSize: 16 }} />
      }
    >
      {loading ? 'Exporting...' : 'Export'}
    </Button>
  );
};

export default ExportButton;
